<template>
	<div class="validation">
		<div v-if="!minimal">
			<b-container style="margin: 0; padding: 0; max-width: none">
				<b-row>
					<b-col cols="9">
						<h1 v-if="node_workflow && node_workflow.description">{{node_workflow.description}}</h1>
						<h1 v-else>{{validation.title}}</h1>
					</b-col>
					<b-col>
						<b-select v-if="names.length > 1 && (!workflow || (workflow && worflow_builder))" @change="load_name()" v-model="name" :options="names"></b-select>
					</b-col>
				</b-row>
			</b-container>

			<p v-if="node_workflow && node_workflow.long_description">{{ node_workflow.long_description }}</p>

			<div v-if="reset == false && workflow_in_nb == 0" class="vcard">
				<h3>Données</h3>

					<label class="form-label">Source</label>&nbsp;
					<b-select v-model="type_data_start" :options="type_data_list" />

				<br /><br />

				<b-container style="margin: 0; padding: 0; max-width: none">
					<b-row>
						<b-col v-if="type_data_start == 'tabulator'">
							<edit_tabulator
								@update="import_file(false)"
								ref="start_tabulator"
								:hidden="true"
							></edit_tabulator>
							<edit_tabulator_conditions
								:default_visible="view_import_data ? true : false"
								:data="start_data"
								@update="import_file_conditions"
							></edit_tabulator_conditions>
						</b-col>
						<b-col v-if="type_data_start == 'DatabaseRequestView'">
							<DatabaseRequestView 
								:default_visible="view_import_data ? true : false"
								@update="import_file(false)"
								_type="db"
								:minimal="true"
								:test_jwt="test_jwt"
								ref="start_tabulator" />
						</b-col>
						<b-col v-if="type_data_start == 'files_upload'">
							<file_upload 
								:upload="true"
								@update="import_file(false)"
								ref="start_tabulator" />
						</b-col>
						<b-col v-if="type_data_start == 'database'">
							<database
								:default_visible="view_import_data ? true : false"
								@update="import_file(false)"
								:change_table="true"
								:name="false"
								:edit="false"
								:test_jwt="test_jwt"
								ref="start_tabulator"></database>
						</b-col>
						<b-col v-if="type_data_start == 'treatments'">
							<treatment_selector 
								:p_project="type_data_start_project"
								@update="import_file" 
								@add="import_file" 
								ref="start_tabulator"
							/>	
						</b-col>
						<b-col v-if="type_data_start == 'splashsync_categories'">
							<splashsync_categories
								@update="import_file(false)" 
								:client="client"
								:minimal="true"
								ref="start_tabulator" 
							/>
						</b-col>	
						<b-col v-if="type_data_start == 'splashsync_products'">
							<splashsync_products
								@update="import_file(false)" 
								:client="client"
								:minimal="true"
								ref="start_tabulator" 
							/>
						</b-col>	
					</b-row>
				</b-container>
			</div>
			<div v-else-if="workflow_in_nb > 0">
				<!--<b-button @click="get_data_in">Actualiser les données</b-button>-->
				Données initiales : résultat des éléments liés
			</div>

		</div>

		<div v-if="reset == false">
			
			<div v-show="data.length > 0 || treatments.length != 0 || finish_treatments.length != 0">
				
				<div v-if="edit_column_id">
					Colonne id<br />
					<b-select :options="columns_all" v-model="column_id" />
					<br /><br />
				</div>

				<div v-show="column_id">

					<div v-if="integration">
						<b-button v-b-toggle="'modal_integration'" >Intégration</b-button> <br /><br />
					</div>

					<b-collapse :title="'Intégration'" size="xl" ok-only id="modal_integration" static style="">

						<edit_tabulator
							@update="import_file_integration" 
							ref="tabulator_integration" 
						></edit_tabulator>

						<p>Colonne de correspondance</p>

						<b-input v-model="integration_column_id"></b-input>

						<p>Colonnes</p>

						<array_editor @update="import_columns_integration"></array_editor>

						<b-button @click="f_integration">Démarrer l'intégration</b-button>

					</b-collapse>

					<b-container v-show="mode == 'small'" style="margin: 0; padding: 0; max-width: none">
						<b-button variant="link" @click="setOne(0, true)">Mode individuel</b-button>
						<b-row v-for="(line_blocks, id_line) in validation.blocks" :key="line_blocks.uid">
							<b-col :cols="block.size" v-for="(block, idx) in line_blocks.blocks" :key="block.uid">
								<div class="vcard">
									<div style="float: right;">
										<b-button v-if="block.params.configuration && block.params.configuration.activate && !configuration" size="sm" variant="link" @click="setConfiguration(id_line, idx)"><i class="fas fa-cog"></i></b-button>
										<b-button v-if="!block.hide_big_block" size="sm" variant="link" @click="setBig(id_line, idx)"><i class="fas fa-expand-alt"></i></b-button>
									</div>
									<div style="text-align:center">
										<h3>{{block.name}} <span v-if="configuration">- configuration</span></h3>&nbsp;
									</div>
									<d_text format="small" :ref="block.uid" v-if="block.type == 'text'"></d_text>
									<array :tabulator_columns_type="tabulator_columns_type" :action_columns_picking="action_columns_picking" :action_columns="action_columns" @update_actions_column_mapping="update_actions_column_mapping" @update_data_picking="update_data_picking" @launch_treatment="launch_treatment" @update_cell="update_cell" :index="column_id" format="small" :ref="block.uid" v-if="block.type == 'array'"></array>
									<br />
								</div>
							</b-col>
						</b-row>
					</b-container>

					<div style="background-color: white; margin: 10px; padding: 10px; border: 0px solid black; border-radius: 25px;" v-if="mode == 'big'">
						<div style="float: right;">
							<b-button v-if="block.params.configuration && block.params.configuration.activate && !configuration" size="sm" variant="link" @click="setConfiguration()"><i class="fas fa-cog"></i></b-button>
							<b-button size="sm" variant="link" @click="setSmall()"><i class="fas fa-compress-alt"></i></b-button>
						</div>
						<div style="text-align:center">
							<h3 style="font-size: 1.2em;">{{block.name}} <span v-if="configuration">- configuration</span></h3>
						</div>
						<div v-show="!configuration">
							<d_text format="big" ref="block" v-if="block.type == 'text'"></d_text>
							<array :tabulator_columns_type="tabulator_columns_type" :action_columns_picking="action_columns_picking" :action_columns="action_columns" @update_actions_column_mapping="update_actions_column_mapping" @update_data_picking="update_data_picking" @launch_treatment="launch_treatment" @update_cell="update_cell" :index="column_id" format="big" ref="block" v-if="block.type == 'array'"></array>
						</div>
						<div v-if="configuration">
							<configuration :index="column_id" @launch_treatment="launch_treatment" @update_cell="update_cell" ref="configuration"></configuration>
							<b-button @click="configuration = false; setSmall()">Fermer</b-button>
						</div>

						<br />
						<span v-for="(action, idx) in actions" :key="idx">
							<action @launch_treatment="launch_treatment" :source_data="get_data" :action="action"></action>&nbsp;
						</span>
						<br /><br />
					</div>

					<!-- <div v-show="mode == 'one'" id="one">
						<b-button variant="link" @click="setSmall()">Mode tableau</b-button><br />
						<b-button v-if="i_elem > 0" variant="link" @click="setOne(-1)">&lt;</b-button>{{i_elem + 1}} / {{data.length}}
						<b-button v-if="i_elem < data.length - 1" variant="link" @click="setOne(1)">></b-button>
						<div class="vcard" v-for="(line_blocks) in validation.blocks" :key="line_blocks.uid">
							<div v-for="(block) in line_blocks.blocks" :key="block.uid">
								<b style="font-size: 1.2em;">{{block.name}}</b>
								<d_text format="one" :ref="'one-' + block.uid" v-if="block.type == 'text'"></d_text>
								<array :tabulator_columns_type="tabulator_columns_type" :action_columns_picking="action_columns_picking" :action_columns="action_columns" @update_actions_column_mapping="update_actions_column_mapping" @update_data_picking="update_data_picking" @launch_treatment="launch_treatment" @update_cell="update_cell" :index="column_id" format="one" :ref="'one-' + block.uid" v-if="block.type == 'array'"></array>
							</div>
						</div>
						<br />
						<span v-for="(action, idx) in actions" :key="idx">
							<action @launch_treatment="launch_treatment" :source_data="get_data" :action="action"></action>&nbsp;
						</span>
						<br /><br />
					</div> -->

					<b-container v-show="mode == 'one'" id="one" style="margin: 0; padding: 0; max-width: none">
						<b-button variant="link" @click="setSmall()">Mode tableau</b-button><br />
						<b-button v-if="i_elem > 0" variant="link" @click="setOne(-1, true)">&lt;</b-button>{{i_elem + 1}} / {{data.length}}
						<b-button v-if="i_elem < data.length - 1" variant="link" @click="setOne(1, true)">></b-button>
						<b-row v-for="(line_blocks, id_line) in validation.blocks" :key="line_blocks.uid">
							<b-col class="vcard" :cols="block.size" v-for="(block, idx) in line_blocks.blocks" :key="block.uid">
								<b style="font-size: 1.2em;">{{block.name}}</b>
								<d_text format="one" :ref="'one-' + block.uid" v-if="block.type == 'text'"></d_text>
								<array :tabulator_columns_type="tabulator_columns_type" :action_columns_picking="action_columns_picking" :action_columns="action_columns" @update_actions_column_mapping="update_actions_column_mapping" @update_data_picking="update_data_picking" @launch_treatment="launch_treatment" @update_cell="update_cell" :index="column_id" format="one" :ref="'one-' + block.uid" v-if="block.type == 'array'"></array>
							</b-col>
						</b-row>
						<span v-for="(action, idx) in actions" :key="idx">
							<action @launch_treatment="launch_treatment" :source_data="get_data" :action="action"></action>&nbsp;
						</span>
						<br />
						<b-button v-if="i_elem > 0" variant="link" @click="setOne(-1, true)">&lt;</b-button>{{i_elem + 1}} / {{data.length}}
						<b-button v-if="i_elem < data.length - 1" variant="link" @click="setOne(1, true)">></b-button>
						<br /><br />
					</b-container>

					<div v-show="view_export_data != 'desactivate'">
						<b-button v-if="view_export_data" @click="view_export_data = false"><i class="fas fa-eye-slash"></i> données export</b-button>
						<b-button v-if="!view_export_data" @click="view_export_data = true"><i class="fas fa-eye"></i> données export</b-button>

						<br /><br />

						<b-collapse v-model="view_export_data" :id="'collapse' + id">

							<edit_tabulator @update="update_tabulator_export" :_index="column_id" @data_length="set_data_length" :row_updates="false" ref="tabulator_export" :extern_file="false"></edit_tabulator>
						
						</b-collapse>

					</div>

					<span v-for="(action, idx) in actions" :key="idx">
						<action @launch_treatment="launch_treatment" :nb="nb" :source_data="get_data_all" :action="action"></action>&nbsp;
					</span>

					<div v-if="treatments.length > 0">

						<p><b>Traitements en cours</b></p>
						<div v-for="(treatment, idx) in treatments" :key="'treatment_' + idx">
							Traitement {{treatment.id}} - projet {{list_obj_projects_uid[treatment.action.project_id]}}
						</div>

						<br />
					</div>

					<div v-if="finish_treatments.length > 0">
						<p><b>Traitements terminés</b></p>

						<div v-for="(treatment, idx) in finish_treatments" :key="'finish_treatment_' + idx">
							Traitement {{treatment.uid}} - projet {{list_obj_projects_uid[treatment.projet_uid]}} - {{treatment.resultat}}<b-button @click="view_treatment(treatment.uid)"><i class="fas fa-eye"></i></b-button>
						</div>
					</div>


					<div v-if="treatments.length" style="
						position:fixed;
						top:0;
						right:0;
						background-color: white;
						margin: 2px;
						padding: 2px;
						border: 1px solid black;
						border-radius: 5px;
					">
						<i class="fas fa-hourglass-end"></i> {{ treatments.length }} traitement{{ treatments.length > 1 ? 's' : '' }} en cours
					</div>

					<treatmentView v-show="treatment_uid" ref="treatment"></treatmentView>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import edit_tabulator_conditions from "../components/edit_tabulator_conditions.vue";
	import splashsync_categories from "../components/splashsync_categories.vue";
	import splashsync_products from "../components/splashsync_products.vue";
	import configuration from "../components/validation/configuration.vue";
	import treatment_selector from "../components/treatment_selector.vue";
	import DatabaseRequestView from '../views/DatabaseRequestView.vue';
	import edit_tabulator from "../components/edit_tabulator.vue";
	import array_editor from "../components/array_editor.vue";
	import action from "../components/validation/action.vue";
	import treatmentView from "../components/treatment.vue";
	import file_upload from "../components/file_upload.vue";
	import array from "../components/validation/array.vue";
	import text from "../components/validation/text.vue";
	import treatments from "../services/treatments.js";
	import databaseView from "../views/database.vue";
	import projects from "../services/projects.js";
	import library from "../services/library.js";
    import client from "../services/client.js";
	import users from "../services/users.js";
	import tools from "../utils/Tools";
	import store from "../store";
	
	import uniqueId from "lodash.uniqueid";
	import { v4 as uuidv4 } from 'uuid';
	
	const moment = require("moment-timezone");
	const _ = require('underscore');
	const clone = require("clone");
	const __ = require('lodash');
	var XLSX = require("xlsx");
	const vm = require('vm');

	export default {
		name: "validation",
		components: {
			d_text: text,
			array: array,
			edit_tabulator,
			edit_tabulator_conditions,
			action,
			configuration,
			database: databaseView,
			DatabaseRequestView,
			array_editor,
			treatment_selector,
			treatmentView,
			file_upload,
			splashsync_products,
			splashsync_categories
		},
		data() {
			return {
				id: uniqueId(),
				validation: {blocks: []},
				block: {},
				mode: "small",
				names: [],
				name: "",
				data: [],
				i_elem: 0,
				index: 0,
				actions: [],
				timer: null,
				treatments: [],
				finish_treatments: [],
				column_id: "",
				start_column_id: "",
				edit_column_id: false,
				configuration: false,
				start_data: [],
				type_data_start: "tabulator",
				list_obj_projects_uid: {},
				nb: 0,
				columns: [],
				integration_data: [],
				integration_column_id: "",
				integration_columns: "",
				integration: false,
				type_data_start_project: "",
				action_columns: {},
				columns_all: [],
				code: "",
				reset: false,
				treatment_uid: null,
				action_columns_picking: {},
				tabulator_columns_type: {},
				view_import_data: false,
				view_export_data: "",
				type_data_list: [
					{value: 'tabulator', text: 'Tableau'},
					{value: 'database', text: 'Base de données'},
					{value: 'DatabaseRequestView', text: 'Base de données - multitables'},				
					{value: 'treatments', text: 'Traitement'},
					{value: 'files_upload', text: 'Fichiers'}
				]
		};
		},
		props: {
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
			minimal: {
				default: false
			},
			_name: {
				default: ""
			},
			import_data: {
				default: () => {}
			},
			workflow: {
				default: false
			},
			workflow_in_nb: {
				default: 0
			},
			// jwt d'un utilisateur simulé ("tester en tant que"), fourni par ValidationBuilder.vue
			// lors de la prévisualisation. Transmis uniquement aux composants source de données
			// (DatabaseRequestView, database).
			test_jwt: {
				default: null
			}
		},
		watch: {
			import_data: {
				deep: true,
				async handler() {
					//console.log("import_data")
					this.set_data(clone(this.import_data));
				},
			},
			start_data: {
				deep: true,
				async handler() {
					//console.log("start_data")
					//console.log(this.start_data)
					this.set_data(clone(this.start_data));
				},
			}
		},
		methods: {
			update_tabulator_export()
			{
				this.$emit("set_data_in", this.workflow);
			},
			async save_workflow()
			{
				var data = {
					name: this.name
				};

				return data;
			},
			async load_workflow(data)
			{
			},
			async parse_file(file) {
				const reader = new FileReader();
				reader.readAsText(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
			async parse_file_array_buffer(file) {
				const reader = new FileReader();
				reader.readAsArrayBuffer(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
            async file_to_csv(data, filename)
            {
                if (filename.endsWith(".xlsx"))
                {
                    data = await this.parse_file_array_buffer(data);

                    var workbook = XLSX.read(data, { bookType: "csv", dateNF:'yyyy-mm-dd'});
                    data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {raw:false, defval: ""});
                }
                else
                {						
                    data = await this.parse_file(data);

                    data = this.$papa.parse(data, { header: true });
                    data = data.data;
                }

                return data;
            },
			async get_data_in()
			{
				var data = await this.$parent.get_data_in(this.workflow);

				if (data.length > 0)
				{
					if (data[0].type == "csv")
					{
						data = await this.parse_file(data[0].data);

						data = this.$papa.parse(data, { header: true });
						data = data.data;
					}
					else if (data[0] instanceof File)
					{
						data = data[0];

						//console.log("data");
						//console.log(data);
						
						var filename = data.name || data.upload.filename;

						data = await this.file_to_csv(data, filename);
					}
					else
					{
						let filename = data[0].name;

						var data = await treatments.getFileAlyx(
							data[0].url,
							false,
							"blob"
						);
						
						data = await this.file_to_csv(data, filename);
					}
				}
				else
					data = [];

				this.import_file(false, data)
				this.load_name()
			},
			async get_data_out()
			{
				return [{
					name: "data.csv",
					type: "csv",
					data: await this.$refs.tabulator_export.get_data_blob()
				}];
			},
			view_treatment(uid)
			{
				this.treatment_uid = uid;
				this.$refs.treatment.start(uid);
			},
			async set_data(data)
			{
				//console.log("set data")
				//console.log(data)

				if (!data || typeof data == "function")
					return;
				
				if (this.code)
				{
					var context = {
						_: _,
						__:__,
						console: console,
						clone: clone,
						data: data,
						moment: moment,
						uuidv4,
						action_columns: this.action_columns					
					};
		
					data = vm.runInNewContext(this.code + ";data;", context);
				}

				this.columns_all = data.length > 0 ? Object.keys(data[0]) : [];
				if (!this.columns_all.includes(this.column_id))
				{
					if (this.columns_all.includes(this.start_column_id))
						this.column_id = this.start_column_id;
					else
						this.column_id = "";
				}

				var keys = Object.keys((data && data.length > 0) ? data[0] : {});
				for (var i = 0; i < data.length; i++)
				{
					for (var j = 0; j < keys.length; j++)
					{
						if (typeof data[i][keys[j]] == "number")
							data[i][keys[j]] = data[i][keys[j]].toString();
						if (typeof data[i][keys[j]] == "object")
						{
							if (!data[i][keys[j]])
								data[i][keys[j]] = "";
							else
								data[i][keys[j]] = JSON.stringify(data[i][keys[j]]);
						}
					}
				}

				for (var i = 0; i < this.columns.length; i++)
				{
					if (!keys.includes(this.columns[i]))
					{
						for (var j = 0; j < data.length; j++)
						{
							data[j][this.columns[i]] = "";
						}
					}
				}

				this.data = data;
				if (this.$refs.tabulator_export)
				{
					//console.log("set data export")
					//console.log(this.data)
					this.$refs.tabulator_export.set_data(this.data, null, "export");
				}

				for (var i = 0; i < this.validation.blocks.length; i++)
				{
					for (var j = 0; j < this.validation.blocks[i].blocks.length; j++)
					{
						if (this.$refs[this.validation.blocks[i].blocks[j].uid])
						{
							await this.$refs[this.validation.blocks[i].blocks[j].uid][0].load_data(this.data);
						}
					}
				}


				if (this.mode == "one")
					await this.setOne(0);
				if (this.mode == "big")
					await this.$refs.block.load_data(this.data);
			},
            set_data_length(nb)
            {
                this.nb = nb;
			},
			import_file_conditions(data)
			{
				//console.log("import_file_conditions")
				//console.log(data)
				this.set_data(clone(data));
			},
			import_file(add, data = null)
			{
				//console.log("import_file")

				var self = this;

				if (!data)
					data = this.$refs.start_tabulator.get_data();
				if (add)
				{
					var data = this.start_data.concat(data);
					data = tools.standardize_json_all(data);
					this.start_data = data;
				}
				else
					this.start_data = data;

				this.$nextTick(async function () {
					if (self.type_data_start == "files_upload" && !self.column_id)
					{
						self.column_id = "url";

						for (var i = 0; i < self.validation.blocks.length; i++)
						{
							for (var j = 0; j < self.validation.blocks[i].blocks.length; j++)
							{
								if (self.$refs[self.validation.blocks[i].blocks[j].uid])
								{
									//await self.$refs['one-' + self.validation.blocks[i].blocks[j].uid][0].update_param(column_document, "url");
									try { 
										console.log("update_param")
										await self.$refs[self.validation.blocks[i].blocks[j].uid][0].update_param("column_document", "url"); 
									} catch (err) {}
								}
							}
						}
					}
				})
			},
			import_file_integration()
			{
				this.integration_data = this.$refs.tabulator_integration.get_data();
			},
			import_columns_integration(data)
			{
				this.integration_columns = data;
			},
			f_integration()
			{
				this.update_data(this.integration_data, this.integration_column_id, this.integration_columns);
			},
			get_data()
			{
				if (this.mode == "one")
				{
					return this.data.slice(this.i_elem, this.i_elem + 1);
				}
				else if (this.mode == "big")
				{
					var start = this.$refs.block.getStart();
					return this.data.slice(start, start + 10);
				}
				else
					return this.$refs.tabulator_export.get_data();
			},
			get_data_all()
			{
				return this.$refs.tabulator_export.get_data();
			},
			async update_blocks(index, column, data, apply)
			{
				for (var i = 0; i < this.validation.blocks.length; i++)
				{
					for (var j = 0; j < this.validation.blocks[i].blocks.length; j++)
					{
						if (this.validation.blocks[i].blocks[j].type == "array" && this.$refs[this.validation.blocks[i].blocks[j].uid])
						{
							await this.$refs[this.validation.blocks[i].blocks[j].uid][0].set_data_cell(index, column, data, apply);
							if (this.mode == "one")
								await this.$refs['one-' + this.validation.blocks[i].blocks[j].uid][0].set_data_cell(index, column, data, apply);							
							if (this.mode == "big")
								await this.$refs.block.set_data_cell(index, column, data, apply);
						}
					}
				}

			},
			async update_cell(index, column, data)
			{
				//console.log("update_cell - index " + index + " - colonne " + column)
				var self = this;
				var match = this.data.filter(x => {return x[self.column_id] === index })
				if (match.length > 0)
					match[0][column] = data;
				this.$refs.tabulator_export.set_data_cell(index, column, data, true);
				this.update_blocks(index, column, data, true);
			},
			async load_name(name)
			{
				var self = this;

				if (name)
					this.name = name;

				var result = await library.getby_production("validation", self.name.trim(), false, true);

				self.validation = result;
				self.load(self.validation);
			},
			async load(data)
			{
				var self = this;
				self.reset = true;
				await this.$nextTick();
				self.reset = false;
				await this.$nextTick()
				this.validation = data;
				this.actions = data.actions ? data.actions.actions : [];
				this.column_id = data.column_id || "id";
				this.start_column_id = data.column_id || "id";
				this.edit_column_id = data.edit_column_id || false;
				this.integration = data.integration || false;
				this.code = data.code || "";


				this.view_import_data = false;
				if (data.view_import_data)
					this.view_import_data = data.view_import_data;

				this.view_export_data = false;
				if (data.view_export_data && data.view_export_data == "visible")
					this.view_export_data = true;
				else if (data.view_export_data && data.view_export_data == "desactivate")
					this.view_export_data = "desactivate";

				//console.log(this.validation)

				if (data.type_data_start)
					this.type_data_start = data.type_data_start;

				this.columns = [];
				for (var i = 0; i < self.validation.blocks.length; i++)
				{
					for (var j = 0; j < self.validation.blocks[i].blocks.length; j++)
					{
						if (self.validation.blocks[i].blocks[j].params.actions)
						{
							for (var k = 0; k < self.validation.blocks[i].blocks[j].params.actions.actions.length; k++)
							{
								var columns = self.validation.blocks[i].blocks[j].params.actions.actions[k].columns;
								for (var l = 0; l < columns.length; l++)
								{
									if (!this.columns.includes(columns[l]))
										this.columns.push(columns[l])
								}
							}
						}
					}
				}

				if (self.validation.actions)
				{
					for (var k = 0; k < self.validation.actions.actions.length; k++)
					{
						var columns = self.validation.actions.actions[k].columns;
						for (var l = 0; l < columns.length; l++)
						{
							if (!this.columns.includes(columns[l]))
								this.columns.push(columns[l])
						}
					}
				}

				if (this.workflow)
					this.$emit("set_description_node", this.workflow, self.validation.title)

				self.$nextTick(async function () {
					//console.log(data.type_data_start)
					//console.log(this.$refs.start_tabulator)
					if (data.type_data_start == 'database' && this.$refs.start_tabulator)
					{
						this.$refs.start_tabulator.load({table: data.type_data_start_table, event: data.type_data_start_where});
					}
					if (data.type_data_start == 'treatments' && this.$refs.start_tabulator)
					{
						this.type_data_start_project = data.type_data_start_project;
						this.$refs.start_tabulator.load({project: data.type_data_start_project});
					}
					for (var i = 0; i < self.validation.blocks.length; i++)
					{
						for (var j = 0; j < self.validation.blocks[i].blocks.length; j++)
						{
							if (self.$refs[self.validation.blocks[i].blocks[j].uid])
							{
								await self.$refs['one-' + self.validation.blocks[i].blocks[j].uid][0].load(self.validation.blocks[i].blocks[j].params);
								await self.$refs[self.validation.blocks[i].blocks[j].uid][0].load(self.validation.blocks[i].blocks[j].params);
								await self.$refs[self.validation.blocks[i].blocks[j].uid][0].load_data(self.data);
							}
						}
					}
				});
			},
			async setConfiguration(id_line, idx)
			{
				if (this.configuration)
					return;

				var self = this;

				if (this.mode == "small")
				{
					this.mode = "big";
					this.block = this.validation.blocks[id_line].blocks[idx];
					this.index = id_line;
				}

				this.configuration = true;

				self.$nextTick(async function () {
					await self.$refs.block.load(self.block.params);
					await self.$refs.block.load_data(self.data);

					await self.$refs.configuration.load(self.block.params);
					await self.$refs.configuration.load_data(self.data);
				});
			},
			async setBig(id_line, idx)
			{
				var self = this;

				this.mode = "big";
				this.block = this.validation.blocks[id_line].blocks[idx];
				this.index = id_line;

				self.$nextTick(async function () {
					await self.$refs.block.load(self.block.params);
					await self.$refs.block.load_data(self.data);
				});
			},
			async setSmall()
			{
				var self = this;
				this.mode = "small";
				this.configuration = false;
			},
			async setOne(add, scroll = false)
			{
				var self = this;
				this.mode = "one";

				this.i_elem += add;

				for (var i = 0; i < self.validation.blocks.length; i++)
				{
					for (var j = 0; j < self.validation.blocks[i].blocks.length; j++)
					{
						if (self.$refs[self.validation.blocks[i].blocks[j].uid])
						{
							await self.$refs['one-' + self.validation.blocks[i].blocks[j].uid][0].load_data(self.data.slice(this.i_elem, this.i_elem + 1));
						}
					}
				}

				if (scroll)
				{
					await this.$nextTick();
					const oneElement = document.getElementById("one");
					if (oneElement) {
						oneElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				}
			},
			async update_actions_column_mapping(block_i, block_j, idx, columns, old_columns)
			{
				console.log("update_actions_column_mapping")
				/*console.log(block_i)
				console.log(block_j)
				console.log(idx)
				console.log(JSON.stringify(columns))
				console.log(JSON.stringify(old_columns))*/

				this.action_columns[block_i + " " + block_j][idx].picking_columns = columns;

				for (var i = 0; i < this.data.length; i++)
				{
					//console.log(i)
					for (var j = 0; j < old_columns.length; j++)
					{
						//console.log(j)
						//console.log(old_columns[j].to)
						if (this.data[i].hasOwnProperty(old_columns[j].to))
							delete this.data[i][old_columns[j].to];
					}
					//console.log(this.action_columns_picking[block_i + "_" + block_j + " " + idx])
					//console.log(this.data[i][this.column_id])
					if (this.action_columns_picking[block_i + "_" + block_j + " " + idx] 
						&& this.action_columns_picking[block_i + "_" + block_j + " " + idx].hasOwnProperty(this.data[i][this.column_id]))
					{
						var data = this.action_columns_picking[block_i + "_" + block_j + " " + idx][this.data[i][this.column_id]].data;
						//console.log(data)
						var data = this.set_data_picking(columns, data, this.action_columns_picking[block_i + "_" + block_j + " " + idx][this.data[i][this.column_id]].multiple);
						var keys = Object.keys(data);
						for (var j = 0; j < keys.length; j++)
						{
							this.data[i][keys[j]] = data[keys[j]];
						}
					}
				}

				//console.log(clone(this.data))

				if (this.$refs.tabulator_export)
					this.$refs.tabulator_export.set_data(this.data);

				for (var i = 0; i < this.validation.blocks.length; i++)
				{
					for (var j = 0; j < this.validation.blocks[i].blocks.length; j++)
					{
						if (this.$refs[this.validation.blocks[i].blocks[j].uid])
						{
							await this.$refs[this.validation.blocks[i].blocks[j].uid][0].load_data(this.data);
						}
					}
				}

				if (this.mode == "one")
					await this.setOne(0);
				if (this.mode == "big")
					await this.$refs.block.load_data(this.data);

				
			},
			set_data_picking(mapping, datas, multiple)
			{
				var obj = {};
				for (var i = 0; i < mapping.length; i++)
				{
					var keys = Object.keys(datas)
					for (var j = 0; j < keys.length; j++)
					{
						var value = null;
						if (!mapping[i].from)
							value = datas[keys[j]];
						else if (datas[keys[j]].hasOwnProperty(mapping[i].from))
							value = datas[keys[j]][mapping[i].from];
						if (value !== null)
						{
							if (multiple)
							{
								if (!obj[mapping[i].to])
									obj[mapping[i].to] = [];
								obj[mapping[i].to].push(value);
							}
							else
								obj[mapping[i].to] = value;
						}
					}
				}

				var keys = Object.keys(obj);
				for (var i = 0; i< keys.length; i++)
				{
					if (typeof obj[keys[i]] == "object")
						obj[keys[i]] = JSON.stringify(obj[keys[i]]);
				}

				return obj;
			},
			async update_data_picking(column_id, id, mapping, idx_json_value, id_json, id_action_column, idx_action_column, data, multiple)
			{
				console.log('update_data_picking')
				/*console.log(column_id)
				console.log(id)
				console.log(mapping)
				console.log(idx_json_value)
				console.log(data)
				console.log(multiple)*/

				if (!this.action_columns_picking[id_action_column + " " + idx_action_column])
					this.action_columns_picking[id_action_column + " " + idx_action_column] = {};
				if (!this.action_columns_picking[id_action_column + " " + idx_action_column][id])
				{
					this.action_columns_picking[id_action_column + " " + idx_action_column][id] = {idx: []};
					this.action_columns_picking[id_action_column + " " + idx_action_column][id].data = {};
				}
				if (this.action_columns_picking[id_action_column + " " + idx_action_column][id].idx.includes(idx_json_value))
				{
					var index = this.action_columns_picking[id_action_column + " " + idx_action_column][id].idx.indexOf(idx_json_value);
					this.action_columns_picking[id_action_column + " " + idx_action_column][id].idx.splice(index, 1);
					delete this.action_columns_picking[id_action_column + " " + idx_action_column][id].data[idx_json_value];
				}
				else
				{
					if (multiple)
					{
						this.action_columns_picking[id_action_column + " " + idx_action_column][id].idx.push(idx_json_value);
						this.action_columns_picking[id_action_column + " " + idx_action_column][id].multiple = true;
					}
					else
					{
						this.action_columns_picking[id_action_column + " " + idx_action_column][id].idx = [idx_json_value];
						this.action_columns_picking[id_action_column + " " + idx_action_column][id].data = {};
						this.action_columns_picking[id_action_column + " " + idx_action_column][id].multiple = false;
					}
					this.action_columns_picking[id_action_column + " " + idx_action_column][id].data[idx_json_value] = data;
				}
				this.action_columns_picking = clone(this.action_columns_picking);

				var datas = this.action_columns_picking[id_action_column + " " + idx_action_column][id].data;

				var obj = this.set_data_picking(mapping, datas, multiple);

				var columns = Object.keys(obj);
				obj[column_id] = id;

				//console.log(columns)

				this.update_data([obj], column_id, columns);
			},
			async update_data(new_data, column_id, columns, action, treatment, block_i, block_j)
			{
				console.log("update_data");
				/*console.log(new_data);
				console.log(column_id);
				console.log(columns);*/

				if (treatment && treatment.details && treatment.details.details && treatment.details.details.columns_result && treatment.details.details.columns_result.length > 0)
				{
					//console.log(treatment.details.details)
					columns = treatment.details.details.columns_result;
				}

				if (treatment && treatment.details && treatment.details.details && treatment.details.details.tabulator_columns_type)
				{
					this.tabulator_columns_type = {...this.tabulator_columns_type, ...treatment.details.details.tabulator_columns_type};
					var keys = Object.keys(treatment.details.details.tabulator_columns_type);
					for (var i = 0; i < keys.length; i++)
					{
						columns.push({name: keys[i], hidden: true})
					}
				}

				//console.log(columns);

				for (var i = 0; i < columns.length; i++)
				{
					if (typeof columns[i] == "string")
					{
						columns[i] = {name: columns[i]}
					}
				}

				//console.log(columns);

				var data_obj = {};
				var self = this;

				for (var i = 0; i < new_data.length; i++)
				{
					data_obj[new_data[i][column_id]] = new_data[i];
				}

				//console.log(data_obj)

				for (var i = 0; i < this.data.length; i++)
				{
					if (data_obj[this.data[i][column_id]])
					{
						for (var j = 0; j < columns.length; j++)
						{
							if (data_obj[this.data[i][column_id]].hasOwnProperty(columns[j].name))
							{
								if (action && action.return_line)
									data_obj[this.data[i][column_id]][columns[j].name] = data_obj[this.data[i][column_id]][columns[j].name].replaceAll(action.return_line, "\n");

								console.log("set_data_cell - " + columns[j].name + " - " + data_obj[this.data[i][column_id]][columns[j].name] + " - " + this.data[i][this.column_id])
								this.$refs.tabulator_export.set_data_cell(this.data[i][this.column_id], columns[j].name, data_obj[this.data[i][column_id]][columns[j].name], false);
								await this.update_blocks(this.data[i][this.column_id], columns[j].name, data_obj[this.data[i][column_id]][columns[j].name], false);
							}
						}
					}
				}

				console.log(" --- ")

				this.$refs.tabulator_export.set_data_cell_apply(true);
				for (var i = 0; i < this.validation.blocks.length; i++)
				{
					for (var j = 0; j < this.validation.blocks[i].blocks.length; j++)
					{
						if (this.validation.blocks[i].blocks[j].type == "array" && this.$refs[this.validation.blocks[i].blocks[j].uid])
						{
							await this.$refs[this.validation.blocks[i].blocks[j].uid][0].set_data_cell_apply(action, columns);
						}
					}
				}

				this.data = this.$refs.tabulator_export.get_data();
				if (this.mode == "one")
					await this.setOne(0);
				if (this.mode == "big")
					await this.$refs.block.load_data(this.data);

				if (action && action.view_results_below)
					this.$set(this.action_columns, block_i + " " + block_j, columns);

				
			},
			async verify_treatments()
			{					
				for (var i = 0; i < this.treatments.length; i++)
				{
					var treatment = clone(this.treatments[i]);
					var block_i = treatment.block_i;
					var block_j = treatment.block_j;
					var action = clone(treatment.action);

					var treatment = await treatments.get(
						treatment.id
					);

					if (treatment.treatment.resultat == "ok" || treatment.treatment.resultat == "ko")
					{
						this.treatments.splice(i, 1);
						treatment.treatment.independant = action.del || action.independant || false;
						treatment.treatment.view_treatment = action.view_treatment;
						this.finish_treatments.push(treatment.treatment);
						i--;

						if (!action.independant)
						{
							if (treatment.treatment.resultat == 'ok')
							{
								var all_files = await treatments.getFiles(
									treatment.treatment.uid
								);
								var export_type = "export";
								var csv = [];
								for (var j = 0; j < all_files.length; j++)
								{
									if (
										all_files[j].type == export_type &&
										all_files[j].nom_fichier.endsWith(".csv")
									) {
										var csv_data = await treatments.getFile(
											all_files[j].uid,
											all_files[j].nom_fichier,
											false,
											false
										);
										var name_file = all_files[j].nom_fichier;
										var results = this.$papa.parse(csv_data, {
											header: true,
										});
										csv = results.data;
										break;
									}
								}
								await this.update_data(csv, this.column_id, action.columns, action, treatment.treatment, block_i, block_j);
							}
						}
						else
						{
							console.log("independant")
							if (action.view_treatment)
								this.view_treatment(treatment.treatment.uid)
						}
					}
				}
			},
            async launch_treatment(id, action, data, idx_action, treatment_params, block_i = null, block_j = null)
            {
				//console.log(id)
				//console.log(action)
				//console.log(data)

				if (action.del)
				{
					for (var i = 0; i < this.data.length; i++)
					{
						for (var j = 0; j < data.length; j++)
						{
							if (this.data[i][this.column_id] == data[j][this.column_id])
							{
								this.data.splice(i, 1);
								i--;
								break;
							}
						}
					}

					this.$refs.tabulator_export.set_data(this.data);

					for (var i = 0; i < this.validation.blocks.length; i++)
					{
						for (var j = 0; j < this.validation.blocks[i].blocks.length; j++)
						{
							if (this.$refs[this.validation.blocks[i].blocks[j].uid])
							{
								await this.$refs[this.validation.blocks[i].blocks[j].uid][0].load_data(this.data);
							}
						}
					}

					if (this.mode == "big")
						await this.$refs.block.load_data(this.data);
					if (this.mode == "one")
					{
						if (this.data.length == 0)
							this.setSmall();
						else
						{
							document.getElementById("one").scrollIntoView();
							if (this.i_elem >= this.data.length)
								this.setOne(-1);
							else
								this.setOne(0);
						}
					}
				}
				this.treatments.push({id,action, block_i, block_j, independant: action.del || action.independant || false});

				//console.log(this.actions);
				//console.log(idx_action);
				try 
				{
					this.validation.blocks[block_i].blocks[block_j].params.actions.actions[idx_action].treatment_params = treatment_params;
					if (this.$refs[this.validation.blocks[block_i].blocks[block_j].uid])
					{
						await this.$refs[this.validation.blocks[block_i].blocks[block_j].uid][0].set_action(this.validation.blocks[block_i].blocks[block_j].params.actions.actions[idx_action], idx_action, block_i, block_j);
					}
					if (this.mode == "big")
						await this.$refs.block.set_action(this.validation.blocks[block_i].blocks[block_j].params.actions.actions[idx_action], idx_action, block_i, block_j);
					if (this.$refs['one-' + this.validation.blocks[block_i].blocks[block_j].uid])
					{
						console.log("set one")
						await this.$refs['one-' + this.validation.blocks[block_i].blocks[block_j].uid][0].set_action(this.validation.blocks[block_i].blocks[block_j].params.actions.actions[idx_action], idx_action, block_i, block_j);
					}

				}
				catch (err) {}
            },
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.validation) {
				this.$router.push({ name: "profile" });
			}

			var response = await users.getSelf(true);

			this.client = response.client;
			if (response.client && response.client.details && response.client.details.splash)
			{
				this.type_data_list.push({value: 'splashsync_products', text: 'Splash Sync - produits'})
				this.type_data_list.push({value: 'splashsync_categories', text: 'Splash Sync - catégories'})
			}

			store.commit("setVideosBlacklist", null);
			store.commit("setVideosWhitelist", null);
			store.commit("setImagesBlacklist", null);
			store.commit("setImagesWhitelist", null);

			this.timer = setInterval(() => {
				this.verify_treatments()
			}, 15000)

			if (!this.minimal)
			{
				this.names = [];

				if (store.state.user.rules && store.state.user.rules.validation && store.state.user.rules.validation != true) {
					name = store.state.user.rules.validation;
					this.names = name.split("|");
				}
				else
				{
					var result = await library.getby_production("validation");
					//console.log(result)
					for (var i = 0; i < result.element.length; i++)
					{
						if (result.element[i].data.includes('"active":true'))
							this.names.push(result.element[i].name);
					}
				}

				//console.log(this.names)

				this.name = this.names[0];

				if (this.$route.query.name && this.names.includes(this.$route.query.name))
					this.name = this.$route.query.name;

				if (this._name)
					this.name = this._name;

				var result = await library.getby_production("validation", this.name.trim(), false, true);

				this.validation = result;
				this.load(this.validation);
			}
			else if (this._name)
			{
				this.name = this._name;
				var result = await library.getby_production("validation", this.name.trim());

				this.validation = JSON.parse(result.element[0].data);
				this.load(this.validation);
			}

			var list_projects = await projects.getAll(false, false, null, true);

			this.list_obj_projects_uid = {};

			for (var i = 0; i < list_projects.length; i++)
			{
				this.list_obj_projects_uid[list_projects[i].uid] = list_projects[i].libelle;
			}

		},
	};
</script>

<style lang="scss" scoped>
.validation {
	h1 {
		margin-bottom: 1.2rem;
	}
	.vcard {
		background-color: white;
		margin: 0 0 10px 0;
		padding: 25px 20px;
		border-radius: 6px;
		h3 {
			margin-bottom: 0.5rem;
			text-align: left;
		}
	}

	.custom-select, .form-control {
		max-width: 320px;
	}
}
</style>
